import gql from 'graphql-tag';

export const ME_QUERY = gql`
  query Me {
    me {
      id
      uid
      firstName
      lastName
      email
      phone
      userImg
      role
      gender
      createdAt
      updatedAt
      driverInfo {
        bankName
        bankAccountNumber
        beneficiaryName
        yearOfRegistration
        fuelConsumption
        engineSize
        driverLicenceNumber
        idCard
        vehicleCategory
        driverLicenceImages {
          key
          imgPath
        }
        carImages {
          key
          imgPath
        }
        fuelType
      }
      userVehicles {
        id
        make {
          id
          name
        }
        model
        spec {
          engineSize
          fuelConsumption
        }
        fuelTypes {
          id
          type
          price
        }
      }
      userPreferences {
        ladyDrivers
        ecoFriendlyRides
        luxuryCars
        standardCars
        moreThanTwoSeats
      }
    }
  }
`;
